import styled from "styled-components";
import kamyonLight from "../../../images/svg/colors/light/kamyoon-light.svg";
import kamyonDark from "../../../images/svg/colors/dark/kamyoon-dark.svg";
import { Link } from "react-router-dom";
import searchIcon from "../../../images/svg/search.svg";
import searchIconLight from "../../../images/svg/search-light.svg";
import Navbar from "./Navbar";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "../../../features/modal/modalSlice";

const Container = styled.div`
  width: inherit;
  transition: 0.5s width;
  position: fixed;
  top: 0;
  bottom: 0;
  border-right: 1px solid ${({ theme }) => theme.mainBorderColor};
  background-color: ${({ theme }) => theme.mainBgColor};
  z-index: 22;

  .wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    .nav-container {
      border-right: 1px solid ${({ theme }) => theme.mainBorderColor};
      background-color: ${({ theme }) => theme.mainBgColor};
      height: calc(100vh - 210px);
      max-height: calc(100vh - 210px);
    }

    .top-container {
      height: 209px;
      display: flex;
      flex-direction: column;
      padding: 30px;
      .logo-wrapper {
        .kamyoon-logo {
          width: 210px;
        }
      }

      .searchbar-wrapper {
        border-radius: 15px;
        width: 210px;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.secondaryBgColor};
        cursor: pointer;
        margin-top: 40px;
        .search-icon {
          width: 1.6rem;
          height: 26px;
          margin: 0 19px 0 10px;
        }

        span {
          font-weight: var(--font-weight-lg);
          font-size: var(--font-size-md);
        }
      }
    }
  }
`;

const Sidebar = ({navItems}) => {
  const { theme, sidebarState } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  return (
    <Container onClick={(e) => e.stopPropagation()} sidebarState={sidebarState}>
      <div className="wrapper">
        <div className="top-container">
          <Link to={"/"} className="logo-wrapper">
            <img
              className="kamyoon-logo"
              src={theme === "light" ? kamyonLight : kamyonDark}
              alt="Kamyoon"
            />
          </Link>
          <div
            className="searchbar-wrapper"
            onClick={() => dispatch(showModal("search"))}
          >
            <img
              className="search-icon"
              src={theme === "light" ? searchIcon : searchIconLight}
              alt=""
            />
            <span>İşlem Ara</span>
          </div>
        </div>

        <div className="nav-container">
          <Navbar navItems={navItems}/>
        </div>
      </div>
    </Container>
  );
};

export default Sidebar;
